import MarketActivityOverview from './MarketActivityOverview'
// Uncomment the below to migrate to stateful component
// import MarketActivityOverviewContainer from './MarketActivityOverviewContainer'

export { MarketActivityOverview }
export default MarketActivityOverview
// Uncomment the below to migrate to stateful component
// export { MarketActivityOverviewContainer }
// export default { MarketActivityOverviewContainer }
